import { useMemo } from 'preact/hooks';

import { getStreamType } from '../utils/streamType';

import { usePlayer } from './PlayerProvider';
import { useDuration } from './useDuration';

export const useStreamType = () => {
  const player = usePlayer();
  const { duration } = useDuration();

  const streamType = useMemo(() => {
    const jw = player.getJWPlayer();
    const { minDvrWindow } = jw?.getConfig() ?? {};

    return getStreamType(duration, minDvrWindow);
  }, [player, duration]);

  return {
    streamType,
    canSeek: streamType === 'DVR' || streamType === 'VOD',
  };
};
